export default __webpack_public_path__ + "static/media/uploadfiles.a819391c.svg";